import type { InterventionsBatchEditTemplateProps } from "./interventions-batch-edit-template.type";

import { useTranslation } from "react-i18next";

import InterventionTemplateVersionEdit from "@/components/InterventionTemplate/VersionEdit";
import BatchEditForm from "@/modules/batch-edit-form";

import { useInterventionsBatchEditTemplate } from "./interventions-batch-edit-template.hook";

const InterventionsBatchEditTemplate = ({
  interventions,
}: InterventionsBatchEditTemplateProps) => {
  const { t } = useTranslation();
  const {
    form,
    fieldName,
    initialValue,
    onFormChange,
    onFormSubmit,
    isPending,
    hasChanges,
    hasError,
    fieldApiError,
  } = useInterventionsBatchEditTemplate(interventions);

  return (
    <BatchEditForm
      modelKey="intervention"
      form={form}
      fieldName={fieldName}
      initialValue={initialValue}
      onFormChange={onFormChange}
      onFormSubmit={onFormSubmit}
      hasChanges={hasChanges}
      isPending={isPending}
      hasError={hasError}
    >
      <InterventionTemplateVersionEdit
        name={fieldName}
        label={t("intervention:batchEdit.template.label")}
        interventionTemplateId={initialValue}
        validateStatus={fieldApiError ? "error" : "success"}
        help={fieldApiError}
      />
    </BatchEditForm>
  );
};

export default InterventionsBatchEditTemplate;
